const STORAGE_KEY = "nibhv_mfa_setup_context";
let memoryContext = null;

function canUseStorage() {
  return typeof window !== "undefined" && window && window.sessionStorage;
}

export function setMfaSetupContext(context) {
  memoryContext = context || null;
  if (!canUseStorage()) {
    return;
  }
  if (!context) {
    window.sessionStorage.removeItem(STORAGE_KEY);
    return;
  }
  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(context));
}

export function getMfaSetupContext() {
  if (memoryContext) {
    return memoryContext;
  }
  if (!canUseStorage()) {
    return null;
  }

  const rawValue = window.sessionStorage.getItem(STORAGE_KEY);
  if (!rawValue) {
    return null;
  }

  try {
    const context = JSON.parse(rawValue);
    memoryContext = context;
    return context;
  } catch (error) {
    window.sessionStorage.removeItem(STORAGE_KEY);
    return null;
  }
}

export function clearMfaSetupContext() {
  memoryContext = null;
  if (canUseStorage()) {
    window.sessionStorage.removeItem(STORAGE_KEY);
  }
}



// WEBPACK FOOTER //
// ./utils/mfaSetupContext.js